import { useNavigate, useSearchParams } from "react-router-dom";
import './login.css'
import './style.css'
import { useTranslation } from 'react-i18next';
import React, { useState } from "react";
import axios from "axios";
import { API_BASE_URL } from "../../Helpers/apiConfig";

export default function VerificationEmail() {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [msg, setMsg] = useState("");
    const [resending, setResending] = useState(false);
    const [searchParams] = useSearchParams();

    const email = searchParams.get("email");

    const resendCode = async () => {
        setResending(true);
        setMsg("");
        try {
            const res = await axios({
                method: "GET",
                url: `${API_BASE_URL}/User/VerifyUserRequest`,
                params: { username: email },
                headers: {
                    accept: "*/*",
                    "Content-Type": "application/json"
                }
            });

            if (res.data.success) {
                setMsg("Yeni doğrulama kodu e-posta adresinize gönderildi.");
            } else {
                setMsg(res.data.message);
            }
        } catch (err) {
            setMsg(err?.response?.data?.message || err.message);
        }
        setResending(false);
    };

    const verify = async (e) => {
        e.preventDefault();
        try {
            const res = await axios({
                method: "POST",
                url: `${API_BASE_URL}/User/VerifyUser`,
                data: {
                    username: email,
                    hash: document.getElementById("hash").value
                },
                headers: {
                    accept: "*/*",
                    "Content-Type": "application/json"
                }
            });
            console.log(res);
            if (res.status === 200) {
                if (res.data.success) {
                    setMsg("Doğrulandı");
                    navigate("/auth/login");
                } else {
                    setMsg(res.data.message);
                }
            } else {
                setMsg("Beklenmedik Bir Hata Oluştu. Tekrar Deneyiniz.");
            }
        } catch (err) {
            setMsg(err?.response?.data?.message || err.message);
        }
    };
    return (
        <div className="container-fluid h-custom">
            <div className="row d-flex justify-content-center align-items-center">
                <div className="col-md-9 col-lg-6 col-xl-5">
                    <img
                        src="https://api.heryerdeingilizce.com/photo/8f973784-5f77-4ae5-b40e-dc5f9f93c4ed.png"
                        className="img-fluid"
                        alt="Sample"
                    />
                </div>

                <div className="col-md-8 col-lg-6 col-xl-4 offset-xl-1" id="registerForm">
                    <form onSubmit={verify}>
                        <div className="divider d-flex align-items-center my-4">
                            <h2 className="text-center fw-bold mx-3 mb-0">
                                {t("verifyEmail")}
                            </h2>
                        </div>

                        <h3>{msg}</h3>
                        <br />

                        <div className="form-outline mb-3">
                            <label className="form-label" htmlFor="hash">
                                {t("verifyHash")}
                            </label>
                            <textarea
                                id="hash"
                                name="hash"
                                className="form-control form-control-lg"
                                placeholder={t("verifyHash")}
                                required
                            />
                        </div>

                        <div className="text-center">
                            <button
                                type="submit"
                                className="btn btn-success btn-lg"
                                style={{ paddingLeft: "2.5rem", paddingRight: "2.5rem" }}
                            >
                                Gönder
                            </button>
                        </div>
                    </form>

                    <div className="text-center mt-3">
                        <p className="mb-1">Kodunuz geçersiz mi oldu ya da e-postayı bulamıyor musunuz?</p>
                        <button
                            type="button"
                            className="btn btn-outline-secondary"
                            onClick={resendCode}
                            disabled={resending || !email}
                        >
                            {resending ? "Gönderiliyor..." : "Kodu Tekrar Gönder"}
                        </button>
                    </div>

                    <br /><br />
                </div>
            </div>
        </div>
    );
}